import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
	DialogActions,
	withStyles,
	Dialog,
	Typography,
	// Hidden,
	DialogContent,
} from '@material-ui/core'
import { Clear } from '@material-ui/icons'
import Button from 'components/theme/Button'
import {
	closeAddDetailsModal,
	handleCheckboxChange,
	handleModalFieldChange,
	addCustomFields,
} from 'actions/contacts/addOrEdit'
import { createOrUpdateContact } from 'actions/contacts'
import ReactSelect from 'components/theme/Select'
import { themeObj } from 'components/withRoot'
import withMobileDialog from '@material-ui/core/withMobileDialog'

const mapStateToProps = (state) => ({
	modal: state.addOrEditContact.modal,
	modalOpen: state.addOrEditContact.addDetailsModalOpen,
	customAttributes: state.contacts.customAttributes,
	contactCustomAttributes: state.addOrEditContact.fields.custom_attributes,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			closeAddDetailsModal,
			handleCheckboxChange,
			handleModalFieldChange,
			addCustomFields,
			createOrUpdateContact,
		},
		dispatch,
	)

const styles = (theme) => ({
	button: {
		margin: theme.spacing.unit,
	},
	modalPaper: {
		// position: 'absolute',
		// width: theme.spacing.unit * 50,
		// backgroundColor: theme.palette.background.paper,
		// boxShadow: theme.shadows[5],
		padding: 24,
	},
	dialogPaper: {
		overflow: 'visible',
		borderRadius: 35,
		[theme.breakpoints.down('sm')]: {
			borderRadius: 0,
		},
	},
	dialogContentRoot: {
		overflow: 'visible',
	},
	closeIcon: {
		height: 40,
		width: 40,
		backgroundColor: '#014c94',
		position: 'absolute',
		top: -10,
		right: -10,
		borderRadius: '50%',
		cursor: 'pointer',
		[theme.breakpoints.down('sm')]: {
			top: 5,
			right: 5,
		},
	},
})

const customStyles = {
	control: (provided) => ({
		...provided,
		borderRadius: '28px',
		padding: '9px 0',
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 2,
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: themeObj.palette.secondary.main,
		borderRadius: 15,
		padding: 4,
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: '#fff',
	}),
	multiValueRemove: (provided) => ({
		...provided,
		borderRadius: '50%',
		backgroundColor: 'rgba(255, 255, 255, 0.7)',
		marginLeft: 4,
		':hover': {
			backgroundColor: '#fff',
		},
	}),
}

class AddDetailsModal extends Component {
	state = {
		value: null,
	}

	handleCheckboxChange = (name) => (event) => {
		this.props.handleCheckboxChange(name, event.target.checked)
	}

	handleModalFieldChange = (name) => (event) => {
		this.props.handleModalFieldChange(name, event.target.value)
	}

	handleModalCloseOk = () => {
		// const { modal } = this.props
		// const newCustomFields = {}
		// Object.keys(modal).forEach((key) => {
		// 	if (modal[key].checked === true) {
		// 		newCustomFields[`${modal[key].field}`] = {
		// 			color: null,
		// 			value: { [modal[key].type]: '' },
		// 			initialValue: { [modal[key].type]: '' },
		// 		}
		// 	}
		// })

		Promise.resolve(
			this.props.addCustomFields({
				[this.state?.value?.label]: {
					color: null,
					value: { S: '' },
					initialValue: { S: '' },
				},
			}),
		).then(() => this.props.createOrUpdateContact())
		this.props.closeAddDetailsModal()
	}

	handleModalCloseCancel = () => {
		this.props.closeAddDetailsModal()
	}

	render() {
		const {
			classes,
			/* modal, */ modalOpen,
			fullScreen,
			contactCustomAttributes,
		} = this.props

		// const fields = Object.keys(modal).map((key) => {
		// 	return (
		// 		<div key={`customAttributeOnModal-${key}`}>
		// 			<TextField
		// 				disabled={['A', 'B', 'C', 'D'].indexOf(key) === -1}
		// 				value={modal[key].field}
		// 				onChange={this.handleModalFieldChange(key)}
		// 			/>
		// 			<Checkbox
		// 				disabled={modal[key].field.length === 0}
		// 				checked={modal[key].checked}
		// 				onChange={this.handleCheckboxChange(key)}
		// 			/>
		// 			<br />
		// 		</div>
		// 	)
		// })

		const options = this.props.customAttributes
			?.filter?.(
				(customAttribute) =>
					customAttribute.name &&
					!contactCustomAttributes?.[customAttribute?.name],
			)
			?.map?.((customAttribute) => ({
				value: customAttribute,
				label: customAttribute?.name,
				key: `${customAttribute?.name}-customAttributeSelectValue`,
			}))

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="sm"
				open={modalOpen}
				onClose={this.handleModalClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<DialogContent classes={{ root: classes.dialogContentRoot }}>
					<div
						// style={{ top: '25%', left: '38%' }}
						className={classes.modalPaper}
					>
						<div style={{ marginBottom: 25 }}>
							A custom field is a property that describes something outside of
							the available options Vast Reach provides. For example, it can be
							a contact's occupation, job title, their department, etc.{' '}
							<strong>Enter a custom field name</strong> below.
						</div>
						<Typography
							style={{ marginBottom: 13 }}
							variant="h5"
							id="modal-title"
						>
							What should we call this custom field?
						</Typography>
						{/* 					{fields} */}
						<ReactSelect
							styles={customStyles}
							value={this.state.value}
							onChange={(newValue, action) => {
								console.log(action)
								console.log(newValue)
								this.setState({ value: newValue })
							}}
							closeMenuOnSelect
							isClearable={false}
							options={options}
							placeholder="Select or create a new custom field"
							creatable
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						disabled={!this.state?.value}
						variant="contained"
						onClick={this.handleModalCloseOk}
						color="secondary"
						className={classes.button}
					>
						save
					</Button>
					{/* <Hidden mdUp>
						<Button
							onClick={this.handleModalCloseCancel}
							color="secondary"
							className={classes.button}
						>
							cancel
						</Button>
					</Hidden> */}
				</DialogActions>
				{/* <Hidden smDown> */}
				<div
					onClick={this.handleModalCloseCancel}
					className={classes.closeIcon}
				>
					<div style={{ position: 'relative', height: '100%' }}>
						<Clear
							style={{
								color: '#fff',
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
							}}
						/>
					</div>
				</div>
				{/* </Hidden> */}
			</Dialog>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withStyles(styles)(withMobileDialog()(AddDetailsModal)))
